import { inject, Pipe, PipeTransform } from "@angular/core";
import { TranslationService } from "@core-services/translation.service";
import { marked } from "marked";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Pipe({
	name: "markdownTranslate",
	pure: false,
	standalone: false
})
export class MarkdownTranslationPipe implements PipeTransform {
	private readonly sanitizer = inject(DomSanitizer);
	public constructor(private translationService: TranslationService) {}

	public transform(key: string, value: (number | string)[] = null, empty: boolean = false): string | SafeHtml {
		if (!key || key.length === 0) {
			return "";
		}
		let trans: string = this.translationService.translate(key, value);

		trans = marked.parse(trans, { async: false });
		const transSanitized = this.sanitizer.bypassSecurityTrustHtml(trans);
		return empty && transSanitized === key ? "" : transSanitized;
	}
}
